import React, { useEffect } from "react";
import { useDispatch } from "utils/redux";
import { setCurrentSection } from "reducers/main";
import { SECTION } from "constants/SettingsConstants";

type ContainerProps = {
  header?: React.ReactNode;
  footer?: React.ReactNode;
  children: React.ReactNode;
};

const InsurerTPAPageContainer = ({
  header,
  footer,
  children,
}: ContainerProps) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setCurrentSection(SECTION.OPERATIONS));
  }, [dispatch]);

  return (
    <>
      <div className="InsurerTPAPageContainer">
        {header && (
          <div className="InsurerTPAPageContainer__Header">{header}</div>
        )}
        <div className="InsurerTPAPageContainer__Forms">{children}</div>
        {footer && (
          <div className="InsurerTPAPageContainer__Footer">{footer}</div>
        )}
      </div>
    </>
  );
};

export default InsurerTPAPageContainer;
